
import { DexAssessmentData } from "@/domain/entities/DexAssessment";
import { Options, prop, Vue } from "vue-class-component";
import formatDateBasedTimezoneValue from "@/app/infrastructures/misc/common-library/v2/FormatDateBasedTimezoneValue";

class Props {
  data = prop<any>({
    default: new DexAssessmentData()
  });
}
@Options({
  components: {}
})
export default class DetailSTTInformationSection extends Vue.with(Props) {
  formatDate(date: string): string {
    return formatDateBasedTimezoneValue(date, "HH:mm");
  }
  get addressType() {
    return {
      home: this.$t('dexAssessment.home'),
      office: this.$t('dexAssessment.office')
    };
  }
}
